import {lazy} from 'react';

export const SpecialistMessagesAsync = lazy(() =>
    import('./SpecialistMessages')
);
